var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReplay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 24,
    viewBox: "0 0 19 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.36058 14.8856C1.48274 14.8856 0.757042 15.6025 0.90936 16.467C1.12775 17.7065 1.60156 18.8933 2.30717 19.9493C3.30868 21.4481 4.73215 22.6164 6.39759 23.3062C8.06303 23.9961 9.89564 24.1765 11.6637 23.8249C13.4317 23.4732 15.0557 22.6051 16.3304 21.3304C17.6051 20.0558 18.4731 18.4317 18.8248 16.6637C19.1765 14.8957 18.996 13.0631 18.3061 11.3977C17.6163 9.73221 16.4481 8.30874 14.9492 7.30723C13.4504 6.30573 11.6882 5.77118 9.88553 5.77118L9.88553 8.95009C11.0595 8.95009 12.207 9.2982 13.1831 9.9504C14.1592 10.6026 14.92 11.5296 15.3692 12.6142C15.8185 13.6987 15.936 14.8922 15.707 16.0435C15.478 17.1949 14.9126 18.2525 14.0826 19.0826C13.2525 19.9127 12.1949 20.478 11.0435 20.707C9.89211 20.9361 8.69868 20.8185 7.61411 20.3693C6.52954 19.92 5.60255 19.1593 4.95035 18.1832C4.59454 17.6507 4.32924 17.0671 4.16159 16.4561C3.92931 15.6096 3.23841 14.8856 2.36058 14.8856V14.8856Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.89261 7.74478C4.63626 7.50797 4.63625 7.10288 4.89261 6.86606L9.79308 2.3392C10.1762 1.98532 10.7971 2.25703 10.7971 2.77856L10.7971 11.8323C10.7971 12.3538 10.1762 12.6255 9.79308 12.2716L4.89261 7.74478Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplay);
export default __webpack_public_path__ + "static/media/replay.628d8f03459eec6e4afe8f33cc10b5fc.svg";
export { ForwardRef as ReactComponent };